import type { MRDrawerItem } from "../../../components/MRDrawer";
import { useWorkspaceUiStore } from "../../../stores/useWorkspaceUiStore";
import { useDeviceStore } from "../../../stores/useDeviceStore";

export const useDrawer = ({
  items,
  navigateToPage,
}: {
  items: MRDrawerItem[];
  navigateToPage: (page: string) => void;
}) => {
  const isMobile = useDeviceStore((state) => state.isMobile);
  const { setExpanded } = useWorkspaceUiStore();

  const handleToggleDrawer = () => {
    setExpanded((prevState) => !prevState);
  };

  const handleSelect = (text: string) => {
    if (isMobile) setExpanded((prevState) => !prevState);
    navigateToPage(text);
  };

  return {
    drawerItems: items,
    handleSelect,
    handleToggleDrawer,
  };
};
